import { useMemo } from 'react';

const useBusinessLocations = data => {
  const formatLocations = locations =>
    locations.map(location => {
      const { address } = location;
      const {
        street,
        suburb,
        state,
        postcode,
        geo,
        map_pin: mapPin,
        street_text: streetText,
        display_suburb: displaySuburb,
        display_suburb_valid: displayValid,
        display_suburb_empty: displayEmpty,
        display_suburb_state: displayState,
        display_suburb_postcode: displayPostcode,
      } = address || {};

      let validSuburb = suburb;
      if (displaySuburb && displayValid && !displayEmpty) {
        validSuburb = `${displaySuburb} ${displayState}${
          displayPostcode ? ` ${displayPostcode}` : ''
        }`;
      }

      const addressParts = {
        streetText,
        street,
        suburb: validSuburb,
        state,
        postcode,
      };

      const addressText = `${streetText || ''} ${street || ''} ${suburb || ''}`;

      return {
        ...address,
        suburb: validSuburb,
        mapPin,
        streetText,
        address: addressText,
        lat: geo && Number(geo.split(',')[0]),
        lng: geo && Number(geo.split(',')[1]),
        addressParts,
        directions: mapPin
          ? `https://www.google.com/maps?q=${geo ||
              encodeURIComponent(addressText)}`
          : `https://www.google.com/maps?q=${encodeURIComponent(addressText)}`,
      };
    });

  const locations = useMemo(() => (data ? formatLocations(data) : []), [data]);
  const hasMapPin = useMemo(
    () =>
      data && !!data.length
        ? data
            .map(({ address: { map_pin: mapPin } = {} }) => mapPin)
            .includes(true)
        : false,
    [data]
  );

  return { locations, formatLocations, hasMapPin };
};
export default useBusinessLocations;
